import { Alert, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import CustomButton from '../../elements/CustomButton';
import Modal from '../../../ui/layout/Modal';
import TextInput from '../../elements/TextInput';
import ExecutionScopeForm from '../../elements/common/execution/ExecutionScopeForm';
import ExecutionScopeAlert from '../../elements/common/execution/ExecutionScopeAlert';
import CustomInputField from '../../../ui/primitives/CustomInputField';

const AddTestSuite = ({
  initialValues,
  onSubmit,
  open,
  handleClose,
  mode,
  error,
  isScopeDefined,
  isPlatformsDefined,
  projectId,
}) => {
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Test suite name is required.')
      .test(
        'has-letter',
        'Test suite name must contain at least one letter.',
        (value) => /[a-zA-Z]/.test(value)
      )
      .test(
        'valid-characters',
        'Test suite name can only include letters, numbers, spaces, or hyphens (-).',
        (value) => /^[a-zA-Z0-9\s-]*$/.test(value)
      )
      .min(1, 'Test suite name must be at least 1 character long.'),
    description: Yup.string(),
  });

  return (
    <Modal
      open={open}
      modalTitle={mode === 'add' ? 'Add Test Suite' : 'Edit Test Suite'}
      handleClose={handleClose}>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}>
        {({ errors, touched, handleSubmit, values, setFieldValue }) => {
          const handleChange = (field, value) => {
            setFieldValue(field, value);
          };

          return (
            <Form noValidate onSubmit={handleSubmit}>
              {!isPlatformsDefined && (
                <ExecutionScopeAlert projectId={projectId} />
              )}

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CustomInputField
                    id="name"
                    label="Name"
                    required
                    value={values.name}
                    onChange={handleChange}
                    placeholder="Enter Test Suite Name"
                    maxLength={50}
                    error={touched.name && errors.name}
                  />
                </Grid>

                <Grid item xs={12}>
                  <CustomInputField
                    id="description"
                    label="Description"
                    value={values.description}
                    onChange={handleChange}
                    maxLength={255}
                    placeholder="Enter Description"
                    multiline
                    rows={3}
                    error={touched.description && errors.description}
                  />
                </Grid>
              </Grid>

              {isScopeDefined && (
                <>
                  <hr />
                  <ExecutionScopeForm
                    values={values}
                    setFieldValue={setFieldValue}
                  />
                </>
              )}

              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}

              <CustomButton disabled={!values.name} />
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AddTestSuite;